import React from 'react';
import { required, useRecordContext, useTranslate } from 'react-admin';
import SelectInput from '../../../../base/components/ra/inputs/SelectInput';
import { useEnumOptions } from '../../../../base/hooks';

const ImplementationWalletInput = (props) => {
  const t = useTranslate();
  const walletImplementationChoices = useEnumOptions('wallet-integration', 'implementation');
  const record = useRecordContext();

  return (
    <SelectInput
      label="resources.brand.fields.implementation"
      source="implementation"
      choices={walletImplementationChoices}
      validate={required(t('ra.validation.required'))}
      disabled={!!record?.walletIntegration}
      resettable={!record?.walletIntegration}
      {...props}
    />
  );
};

export default ImplementationWalletInput;
